<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-partners-subnav></app-partners-subnav>
    </app-sidebar>

    <app-content>
        <p>This is the company settings component!</p>
    </app-content>
</app-app-holder>
